// import React from "react";
import "../../OrderComponents/OrderTabs.css";
// import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
// import { useSelector } from "react-redux";

// import { useEffect } from "react";
// import { useLocation, NavLink } from "react-router-dom";
// import api from "../../../seller-apis/api";

const UnlockPopupSuccess = ({show,handleUnlockClose}) => {
  
  return (
    <Modal className='custom-modal1 lead-unlock1' centered   show={show} onHide={handleUnlockClose}>
      <div class="header-pop justify-content-end text-right mt-2">
        
        <a class="close-pop me-3 cursor-pointer" style={{fontSize:22}} onClick={() => handleUnlockClose()}>
          ×
        </a>
      </div>
      <Modal.Body style={{marginTop:'-22px'}}>
        <div className="text-center"><img src="/checked.png" style={{width: '7%'}} /></div>
        <p className='unlock-title py-2'>Success</p>
        {/*<p className='unlock-sub-title fs-14'>Leads unlocked successfully and added to your "Purchase Leads" section</p>*/}
        <p className='unlock-sub-title fs-14'>Leads unlocked successfully!</p>
        {/*<div className="py-3 text-center">
          <NavLink to="/customer-leads/details" style={{color: '#329998',textDecoration:'underline'}}>Go to Purchase Leads</NavLink>
        </div>*/}
        
      </Modal.Body>
    </Modal>
  );
};

export default UnlockPopupSuccess;
